import { useRouter } from "@/utils";
import { labelingParamsAtom } from "../../state";
import { useAtomValue } from "jotai";
import { clsx } from "clsx";
import { FileNode } from "./FileNode";
import { FileTree } from "../../Labeling.types";
import { LabeledFileItem } from "./LabeledFileItem";
import { DraftItem } from "./DraftItem";
import { CreateDraftItem } from "./CreateDraftItem";

export function TreeRootItem({
    name,
    draft,
    labeledFiles,
    date,
    id,
}: FileTree) {
    const router = useRouter();
    const companyId = router.params.companyId as string;
    const { selectedFileId, selectedDraftId } =
        useAtomValue(labelingParamsAtom);
    const hasDraft = draft !== null;
    const hasLabeledFiles = labeledFiles.length > 0;
    const isSelected = selectedFileId === id && !selectedDraftId;

    const lineElement = (
        <div
            className={clsx(
                "absolute -bottom-10 left-[7px] top-0 w-px border-l-2 border-slate-700",
                !hasDraft
                    ? "mb-[14px] mt-6 border-dashed"
                    : "mb-4 mt-[1.65rem] rounded",
            )}
        />
    );

    return (
        <li className={clsx("relative flex flex-col gap-1")}>
            <FileNode
                icon="check"
                label={name}
                id={id}
                lineElement={lineElement}
                date={date}
                to={`/beta/companies/${companyId}/labeling/files/${id}`}
                isSelected={isSelected}
                bold
            />

            <ul className={clsx("relative flex flex-col gap-4 pt-4")}>
                {hasDraft ? (
                    <DraftItem
                        draft={draft}
                        hasLabeledFiles={hasLabeledFiles}
                        parentId={id}
                    />
                ) : (
                    <CreateDraftItem
                        hasLabeledFiles={hasLabeledFiles}
                        parentId={id}
                    />
                )}

                {hasLabeledFiles && (
                    <li className="relative flex flex-col">
                        <ul className={clsx("flex flex-col gap-1")}>
                            {labeledFiles.map((file, index) => (
                                <LabeledFileItem
                                    key={file.id}
                                    showCircle={index === 0}
                                    {...file}
                                />
                            ))}
                        </ul>
                    </li>
                )}
            </ul>
        </li>
    );
}
